export default __webpack_public_path__ + "static/media/collaborate.85507d60.jpg";